/* global axios */
import ApiClient from './ApiClient';

class SearchConsoleAPI extends ApiClient {
  constructor() {
    super('search_console/reports', { accountScoped: true });
  }

  sites(connectionId) {
    return axios.get(`${this.url}/sites`, {
      params: { connection_id: connectionId },
    });
  }

  report(connectionId, siteUrl, dateRange) {
    return axios.get(this.url, {
      params: {
        connection_id: connectionId,
        site_url: siteUrl,
        date_range: dateRange,
      },
    });
  }
}

export default new SearchConsoleAPI();
